export { ClassGroups, ClassGroup } from './ClassGroups';
export { Clubs } from './Clubs';
export { Competition, Permissions, Status, Operations } from './Competition';
export { CompetitionGroup } from './CompetitionGroup';
export { Discipline } from './Discipline';
export { DivisionGroups, DivisionGroup } from './DivisionGroups';
export { Event } from './Event';
export { Events } from '../logic';
export { Participant } from './Participant';
export { ParticipantScore } from './ParticipantScore';
export { Person } from './Person';
export { Registration } from './Registration';
export { Registry } from './Registry';
export { Results } from './Results';
export { Schedule } from './Schedule';
export { ScoringModels } from './ScoringModels';
export { Squad } from './Squad';
export { StageDef } from './StageDef';
export { TabInfo } from './TabInfo';
export { TeamRegistration } from './TeamRegistration';
export { Team } from './Team';
export { TeamDef } from './TeamDef';
export { Tokens } from './Tokens';

export class Mode {
	static computer = "computer";
	static mobile = "mobile";
}